export const ITEM_SIZE = {
    twoColumns: 45,
    threeColumns: 30,
    fourColumns: 22,
}

export const PROD_IMAGE_WIDTH_PERCENT = 55;
export const PROD_IMAGE_HEIGHT_PERCENT = 55;
